<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ isAdmin ? $t('bank_accounts.type_bk_dbtr') : $t('bank_accounts.slct_bk_dbtr') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="10" md="8" lg="10" xl="8">
                  <select-bank-account v-model="bankAccount" v-if="!isAdmin"
                    labelClass="createInvoiceBand mb-0"
                    inputClass="d-flex align-items-center icon-input bank-account-icon"
                    inputIcon="fa-solid fa-building-columns text-info">
                  </select-bank-account>
                  <form-write-group-label-input v-model="bankAccount" isMandatory
                    labelClass="mb-0"
                    :inputLabel="$t('bank_accounts.bank_account_singular')"
                    :specificErrorIndicator="bankAccountError"
                    :specificMessage="bankAccountErrorMessage">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 m-0">
              <b-button variant="primary" :disabled="!bankAccount"
                @click="selectBankAccount()">
                {{ $t('common.pay') }}
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'

import {validateIBAN, validateIBANRIBKey} from '@/helpers/validator.js'

export default {
  name: 'ChoiceBankAccount',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'select-bank-account': selectBankAccount
  },
  computed: {
    isAdmin () {
      return this.$engine.rights.rightIs('rtp_consulter_admin', true)
    }
  },
  data () {
    return {
      bankAccount: '',
      bankAccountError: false,
      bankAccountErrorMessage: '',
      mousedown: false
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    selectBankAccount () {
      if (!validateIBAN(this.bankAccount) || !validateIBANRIBKey(this.bankAccount)) {
        this.bankAccountError = true
        this.bankAccountErrorMessage = this.$i18n.t('errors.dbtr_invld_bnk')
        return
      } else {
        this.bankAccountError = false
      }
      this.$emit('close')
      this.data.bankAccount = this.bankAccount
      this.$bus.$emit('pay-transaction', this.data)
    }
  }
}
</script>
<style scoped>
.modal-action {
  cursor: pointer;
  padding: 10px;
}
.modal-action:hover {
  background-color: rgba(50, 50, 50, 0.1);
}
.modal-action-title {
  font-size: 16px;
}
.modal-action-subtitle {
  font-size: 16px;
  font-weight: bold;
}
.modal-action-text {
  font-size: 14px;
}
@media (max-width: 575px) {
  .modal-action-right {
    border-top: 1px solid #000;
  }
}
@media (min-width: 576px) {
  .modal-action-right {
    border-left: 1px solid #000;
  }
}
</style>
